import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import ScrollAnimation from './views/directives/scrollanimation'
import CursorFx from '@luxdamore/vue-cursor-fx';
import '@luxdamore/vue-cursor-fx/dist/CursorFx.css';
import VueLazyload from 'vue-lazyload'
import VueJsonLD from 'vue-jsonld'
 
Vue.use(VueJsonLD)

Vue.use(CursorFx);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@/assets/now_loading.png'),
  loading: require('@/assets/now_loading.png'),
  attempt: 1
})

Vue.directive('scrollanimation', ScrollAnimation);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
